export const QUERY_PARAMS = {
  REQUEST_ID: 'request-id',
  BANK_ID: 'bank-id',
  CODE: 'code',
  SCOPE: 'scope',
  STATE: 'state',
};
